import { render } from "./DocumentClassFieldTable.vue?vue&type=template&id=73d7a38c&scoped=true&ts=true"
import script from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldTable.vue?vue&type=style&index=0&id=73d7a38c&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d7a38c"]])

export default __exports__